module.exports = __webpack_public_path__ + "media/images/static/offer/lp_s03-ttl_s-9aec35c629d12dbd821465fc6691a1da.png";